import React, { useEffect } from 'react';
import ContactSection from '@/components/site/ContactSection';

export default function ContactPage() {
  useEffect(() => { document.title = 'Contact Cespedis | Commercial Real Estate Hyderabad'; }, []);
  return (
    <div data-testid="contact-page">
      <section className="relative isolate overflow-hidden bg-[#144726] pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#144726] via-[#1A5A33] to-[#144726]" />
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C6A35B]">Contact</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white tracking-tight">Let’s discuss your property.</h1>
          <p className="mt-4 max-w-2xl text-base md:text-lg text-white/75">Share a brief about your asset or requirement. We respond within one business day.</p>
        </div>
      </section>
      <ContactSection />
    </div>
  );
}
